import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import SEO from "@/components/SEO";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { adminLogin, formatApiError } from "@/lib/admin";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminLogin(form.email, form.password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-16" data-testid="admin-login-page">
      <SEO title="Admin Login" />
      <div className="w-full max-w-sm rounded-2xl bg-white border border-slate-200 shadow-xl p-8">
        <div className="flex justify-center"><img src="/logo-header.png" alt="D Travel Link" className="h-16 w-auto" /></div>
        <h1 className="mt-4 text-center font-heading text-2xl font-extrabold text-navy">Admin Login</h1>
        <p className="mt-1 text-center text-xs text-slate-400">D Travel Link content management</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="ad-email">Email</Label>
            <Input id="ad-email" data-testid="admin-email-input" type="email" required
                   value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                   className="h-11 rounded-xl" placeholder="you@dtravellink.com" />
          </div>
          <div>
            <Label htmlFor="ad-pass">Password</Label>
            <Input id="ad-pass" data-testid="admin-password-input" type="password" required
                   value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                   className="h-11 rounded-xl" placeholder="••••••••" />
          </div>
          <Button type="submit" disabled={busy} data-testid="admin-login-button"
                  className="w-full h-11 rounded-full bg-navy text-white font-heading font-bold hover:bg-royal transition-colors">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <span className="flex items-center gap-2"><Lock className="w-4 h-4" /> Sign In</span>}
          </Button>
        </form>
      </div>
    </div>
  );
}
